import { createRoute } from '@tanstack/react-router';
import { pharmacyParentRoute } from 'pages/pharmacy/pharmacyParentRoute';
import { zodPathParamId } from 'routes/routeUtils';
import { z } from 'zod';

export const pharmacyClaimRoute = createRoute({
  getParentRoute: () => pharmacyParentRoute,
  path: '/claims/$id',
  params: z.object({ id: zodPathParamId }),
}).lazy(() =>
  import('pages/pharmacy/Cases/Claims/PharmacyClaimPage/PharmacyClaimPage').then((d) => d.Route)
);
